
import AppFullscreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppContactSearch from "@/components/contacts/ContactSearchWithBrowseAndCreate.vue";
import AppSaleSearch from "@/components/sales/SaleSearchWithBrowse.vue";
import AppPurchaseSearch from "@/components/purchases/PurchaseSearchWithBrowse.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import { Car, Contact, Purchase, Sale } from "@/models/base";
import Vue from "vue";
import { DefaultEditTab, getVisibleDefaultEditTabs } from "@/utils/tabs/default-edit-tabs";
import { CarService } from "@/services/car-service";
import AppCarAwsDocuments from "@/components/cars/CarAwsDocuments.vue";
import { TranslateResult } from "vue-i18n";
import {DossierConfigService} from "@/services/dossier-config-service";
import AppExtraFieldsEdit from "@/components/ExtraFieldsEdit.vue";
import AppExtraFieldTab from "@/components/ExtraFieldTab.vue";
import { ExtraFieldTabConfig } from "@/models/dossier-configs/extra-field-tab-config";
import { ExtraFieldNamesConfig } from "@/models/dossier-configs/extra-field-names-config";

export default Vue.extend({
	data() {
		return {
			pendingChanges: false,
			activeTab: 0,
		};
	},
	props: {
		car: Object as () => Car,
	},
	computed: {
		defaultTabs(): DefaultEditTab[] {
			return getVisibleDefaultEditTabs(13);
		},
		currentTabKey(): string {
			return this.defaultTabs[this.activeTab]?.key || "";
		},
		tabs(): TranslateResult[] {
			let tabs:TranslateResult[] = this.defaultTabs.map(t=>t.label());
			return [...tabs, ...this.extraFieldSettings.getTabNames()];
		},
		extraFieldTabs():ExtraFieldTabConfig[] {
			return this.extraFieldSettings.getTabs();
		},
		hasCarpassConfigured():boolean {
			return DossierConfigService.getCarpassConfig().isConfigured();
		},
		extraFieldSettings():ExtraFieldNamesConfig{
			return DossierConfigService.getReadonlyExtraFieldNamesConfigs().CarNames;
		}
	},
	watch: {
		bank: {
			deep: true,
			handler(car: Car, oldCar: Car) {
				if (oldCar != car) return;
				this.pendingChanges = true;
			}
		},
		"car.CustomLabel": {
			immediate: true,
			handler(){
				this.car.CustomLabel = this.car.CustomLabel.toUpperCase();
			}
		},
		"car.Plate": {
			immediate: true,
			handler(){
				this.car.Plate = this.car.Plate.toUpperCase();
			}
		}
	},
	methods: {
		async save() {
			if(this.car.ID){
				await CarService.putCar(this.car);
			}else{
				await CarService.postCar(this.car);
			}
			this.pendingChanges = false;
			this.$wf.notify(this.$ct("save-success").toString(), "success", 3000, "check");
			this.$emit("car-saved");
			await this.$router.push("/cars");
		},
		uploadAwsDocuments(){
			this.$emit("upload");
		},
		selectPurchase(purchase:Purchase){
			this.car.Purchase = purchase;
			this.car.PurchaseID = purchase.ID;
		},
		selectSale(sale:Sale){
			this.car.Invoice = sale;
			this.car.InvoiceID = sale.ID;
		},
		selectContact(contact:Contact){
			this.car.Contact = contact;
			this.car.ContactID = contact.ID;
		},
		selectSupplier(contact:Contact){
			this.car.Supplier = contact;
			this.car.SupplierID = contact.ID;
		},
		cancel() {
			this.$emit("cancel");
		}
	},
	async mounted() {

	},
	components: {
		AppFullscreenContainer,
		AppToolbar,
		AppContactSearch,
		AppSaleSearch,
		AppPurchaseSearch,
		AppCarAwsDocuments,
		AppExtraFieldsEdit,
		AppExtraFieldTab
	},
	i18nEx: {
		componentPrefix: "components.car"
	}
});
